import { render, staticRenderFns } from "./AccountBox.vue?vue&type=template&id=036ac399&scoped=true"
import script from "./AccountBox.vue?vue&type=script&lang=js"
export * from "./AccountBox.vue?vue&type=script&lang=js"
import style0 from "./AccountBox.vue?vue&type=style&index=0&id=036ac399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ac399",
  null
  
)

export default component.exports